export default "__VITE_ASSET__DYV0idjE__"